import { ModuleTranslationProvider } from '../../../contexts/ModuleTranslation'

import BusinessConnect from './BusinessConnect'
import translations from './locales'
import useCart from '../../../hooks/useCart'
import { getBusinessConnectService, shouldRender } from './utils'

import useFeatureFlags from '../../../hooks/useFeatureFlags'

const BusinessConnectContainer = () => {
  const { cart } = useCart()
  const { data: featureFlags } = useFeatureFlags()

  if (!shouldRender(cart, featureFlags)) return null
  const businessConnect = getBusinessConnectService(cart)

  return (
    <ModuleTranslationProvider translations={translations} module="businessConnect">
      <BusinessConnect
        key={businessConnect.id}
        cart={cart}
        featureFlags={featureFlags}
        businessConnect={businessConnect}
        isRemoveButtonHidden={false}
      />
    </ModuleTranslationProvider>
  )
}

export default BusinessConnectContainer
